export const SlaDashboard = () =>
  import('./SlaDashboard').then(({ SlaDashboard }) => ({
    Component: SlaDashboard
  }));
